module.exports = __webpack_public_path__ + "static/media/st_details_view_all_details.1dba2ab6.svg";